import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntriesTable from "./EntriesTable";

const HouseQuinella = ({
  raceInfo,
  entriesInfo,
  idHouseQ,
  idBox,
  addToCart,
  disabledAll,
  checkBoxState,
}) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="HouseQ"
        role="tabpanel"
        aria-labelledby="HouseQ"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.HOUSEQ.name}
          idWT={idHouseQ}
          idBox={idBox}
          addToCart={addToCart}
          disabledAll={disabledAll}
          checkBoxState={checkBoxState}
        />
      </div>
    </>
  );
};

export default HouseQuinella;
